module.exports = __webpack_public_path__ + "static/media/image14.fe13294f.jpg";